function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 18.879,
  width: 155,
  height: 110,
  rx: 8.533,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M184.771 101.106v19.768H49.533V51.606l19.98 29.86c3.237 4.833 11.305 4.44 19.88-.988 8.341-5.28 16.236-5.81 19.636-1.328l15.038 19.842c1.32 1.742 3.958 3.888 11.173 3.453 2.101-.128 4.8-1.912 6.556-4.313l5.124-7.043c1.756-2.41 4.698-3.58 5.693-2.262l8.605 11.429c.913 1.211 2.415 1.827 4.323 1.785l19.24-.935h-.01z",
  fill: "url(#go-to-market_svg__a)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M50.441 52.557l19.98 29.86c3.238 4.833 11.305 4.44 19.88-.988 8.342-5.28 16.237-5.81 19.636-1.328l15.039 19.842c1.319 1.742 3.958 3.888 11.173 3.452 2.1-.127 4.799-1.912 6.555-4.312l5.125-7.043c.355-.478.872-.881 1.501-1.2 3.349-1.72 7.418-.149 9.174 3.293l3.623 7.074c.913 1.211 2.415 1.827 4.323 1.785h19.24",
  stroke: "url(#go-to-market_svg__b)",
  strokeWidth: 3.777,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 18.879,
  width: 155,
  height: 110,
  rx: 8.533,
  stroke: "#E6E6E6",
  strokeWidth: 8
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M136.653 45.947l-.063 14.285c-7.814-.09-14.222-6.571-14.222-14.385 0-3.626 1.378-7.106 3.852-9.735l10.433 9.835z",
  fill: "#EEE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M136.653 45.947l-10.406-9.862a14.203 14.203 0 0110.406-4.424c7.841.055 14.286 6.554 14.286 14.386 0 7.831-6.445 14.24-14.286 14.185h-.072l.072-14.285z",
  fill: "#39F"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M132.809 42.109c-2.102 2.102-2.088 5.526.032 7.646 2.121 2.12 5.544 2.135 7.647.032 2.103-2.103 2.088-5.526-.032-7.646-2.121-2.12-5.544-2.135-7.647-.032z",
  fill: "#FAFAFA"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M169.285 45.947l.063-14.286c7.814.091 14.222 6.572 14.222 14.386a14.2 14.2 0 01-3.852 9.735l-10.433-9.835z",
  fill: "#424242"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M169.285 45.947l10.406 9.862a14.203 14.203 0 01-10.406 4.423c-7.841-.054-14.286-6.553-14.286-14.385 0-7.831 6.445-14.24 14.286-14.186h.072l-.072 14.286z",
  fill: "#39F"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M173.129 49.785c2.102-2.102 2.088-5.526-.032-7.646-2.121-2.12-5.544-2.135-7.647-.032-2.102 2.102-2.088 5.526.032 7.646 2.121 2.12 5.544 2.135 7.647.032z",
  fill: "#FAFAFA"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M34.889 145.853c19.268 0 34.888-15.62 34.888-34.888 0-19.269-15.62-34.889-34.889-34.889C15.62 76.076 0 91.696 0 110.965c0 19.268 15.62 34.888 34.889 34.888z",
  fill: "url(#go-to-market_svg__c)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M19.035 110.312l10.705 10.705 20.476-20.467",
  stroke: "#FAFAFA",
  strokeWidth: 6.101,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "go-to-market_svg__a",
  x1: 151.044,
  y1: 33.907,
  x2: 160.204,
  y2: 104.296,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39F",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#39F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "go-to-market_svg__b",
  x1: 56.35,
  y1: 44.977,
  x2: 191.67,
  y2: 67.466,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#63C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "go-to-market_svg__c",
  x1: 3.049,
  y1: 65.684,
  x2: 74.511,
  y2: 70.153,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#63C"
})));

function SvgGoToMarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 146,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

export default "data:image/svg+xml;base64,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";
export { SvgGoToMarket as ReactComponent };